export function addAuthKey (url, token) {
    return `${url}&auth_key=${token}`;
}